import { useState } from "react";
import NavigationTabs from "../../../../utils/components/NavigationTabs";
import Modal from "../../../../utils/components/Modal";
import StepResults from "../StepEdit/components/StepResults";
import StepInfo from "./components/StepInfo";

const AutoStepNodeEdit = ({
  translate,
  isModalOpen,
  onModalClose,
  handlePositiveButtonClick,
  stepData,
  stepsList,
}) => {
  const [step, setStep] = useState(stepData);
  const [activeTab, setActiveTab] = useState(
    translate("design_approval_process.step-edit-modal.step-information")
  );

  const handleAction = (type, data) => {
    switch (type) {
      case "step_info":
        handleStepInfo(data);
        break;
      case "step_results":
        handleStepResults(data);
        break;
      default:
        break;
    }
  };

  const handleStepResults = (stepResults) => {
    setStep({
      ...step,
      settings: {
        ...step.settings,
        results: stepResults,
      },
    });
  };

  const handleStepInfo = (stepInfo) => {
    setStep({
      ...step,
      settings: {
        ...step.settings,
        step_info: {
          info_title: stepInfo.textTitle,
          info_description: stepInfo.textContent,
          code: stepInfo.code,
        },
      },
    });
  };

  return (
    <div>
      <Modal
        title={translate(
          "design_approval_process.step-edit-modal.auto-step-edit"
        )}
        positiveButtonNode={translate("save")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={() => handlePositiveButtonClick(step)}
        negativeButtonHandler={() => onModalClose()}
        modalSize="xl"
        show={isModalOpen}
        setShow={() => onModalClose()}
      >
        <div className="border-bottom mb-4">
          <NavigationTabs
            tabs={[
              translate(
                "design_approval_process.step-edit-modal.step-information"
              ),
              translate("design_approval_process.step-edit-modal.step-results"),
            ]}
            activeTab={activeTab}
            onTabClick={(tab) => setActiveTab(tab)}
          />
        </div>
        <div className="ms-3">
          <div className="inner-page mb-5">
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-results"
              ) && (
              <StepResults
                step={step}
                stepsList={stepsList}
                handleAction={handleAction}
                translate={translate}
              />
            )}
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-information"
              ) && (
              <StepInfo
                step={step}
                handleAction={handleAction}
                translate={translate}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AutoStepNodeEdit;
